import { Box, Divider } from "@mui/material";
import InvoiceShowBasicData from "./content/InvoiceShowBasicData";
import InvoiceShowBillingItems from "./content/InvoiceShowBillingItems";
import InvoiceShowPaymentConditions from "./content/InvoiceShowPaymentConditions";
import InvoiceShowCheckout from "./content/InvoiceShowCheckout";
import InvoiceShowCancel from "./content/InvoiceShowCancel";
import InvoiceShowLinkedWorks from "./content/InvoiceShowLinkedWorks";

const InvoiceShowContent= ({ invoice, setLoadingInstallmentsTable, loadingInstallmentsTable}) => {
    return(
        <>
        <Box sx={{display: 'flex', flexDirection: 'column', gap: '4.5rem'}}>
           <InvoiceShowBasicData invoice={invoice} />  
           <InvoiceShowLinkedWorks invoice={invoice} />
           <InvoiceShowBillingItems invoice={invoice} /> 
           <InvoiceShowPaymentConditions invoice={invoice} setLoadingInstallmentsTable={setLoadingInstallmentsTable} loadingInstallmentsTable={loadingInstallmentsTable}/> 
           <InvoiceShowCheckout invoice={invoice} /> 
           <Divider />
           <InvoiceShowCancel invoice={invoice} setLoadingInstallmentsTable={setLoadingInstallmentsTable} loadingInstallmentsTable={loadingInstallmentsTable}/>
        </Box>
        </>
    )
}

export default InvoiceShowContent;